import { Card, Typography } from "@mui/material";
import React from "react";
import { DecorativeCorner } from "../common/DecorativeCorner";
import { styles } from "../styles/styles";
import { FontStyles } from "../styles/FontStyles";
function WhyUsSection() {
	return (
		<div >
			<Card sx={{ ...styles.whyuse,}}>
				<DecorativeCorner
					sx={{ top: -20, left: -20, transform: "rotate(0deg)" }}
				/>
				<DecorativeCorner
					sx={{ top: -20, right: -20, transform: "rotate(0deg)" }}
				/>
				<DecorativeCorner
					sx={{ bottom: -20, right: -20, transform: "rotate(0deg)" }}
				/>
				<DecorativeCorner
					sx={{ bottom: -20, left: -20, transform: "rotate(0deg)" }}
				/>

				<Typography variant="h4" component="h1" sx={styles.heading}>
					Why Annapurna Marriages?
				</Typography>

											 <Typography sx={{ ...FontStyles.aboutText }}>
					Annapurna Marriages Pvt Ltd. is the fastest growing marriage portal in
					Andhra Pradesh & Telangana states the online marriage portal aims to
					serve as a one-stop platform for prospective and grooms to meet and
					communicate with each other!
				</Typography>
			</Card>
		</div>
	);
}

export default WhyUsSection;
